import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicMessage({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M3.25 13.71c-1.24 0-2.25-1-2.25-2.25v-7c0-1.24 1-2.25 2.25-2.25h9.5c1.24 0 2.25 1 2.25 2.25v7c0 1.24-1 2.25-2.25 2.25H11.5v1.04a1.25 1.25 0 01-2.13.89L7.44 13.7H3.25zm6.75-.75c0-.41.34-.75.75-.75h2c.41 0 .75-.34.75-.75v-7a.75.75 0 00-.75-.75h-9.5a.75.75 0 00-.75.75v7c0 .41.34.75.75.75h4.5c.2 0 .39.08.53.22L10 14.15v-1.19zm-5-5.5h6a.75.75 0 100-1.5H5a.75.75 0 000 1.5zm0 2.5h4a.75.75 0 000-1.5H5a.75.75 0 000 1.5z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicMessage.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicMessage.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicMessage svgRef={ref} {...props} />);
export default ForwardRef;
